// frontend/shared-ui/src/forms/schemas/spliceProtector.js
export default {
    slug: 'splice-protector',
    label: 'Splice Protectors & Sleeves',
    defaultUnit: 'bag',
    costDefaults: {
        avgVolumeCbm: 0.00003,
        suggestedMarkupPct: 60,
        freightSensitivity: 'low',
        note: 'Bulk bags of 100 — negligible CBM, high margin',
    },
    groups: [
        {
            id: 'basic',
            label: 'Basic',
            columns: 2,
            fields: [
                { key: 'material', label: 'Material', type: 'select', required: true, options: ['304 Stainless Steel', 'Ceramic', 'Heat-shrink'] },
                { key: 'packSize', label: 'Pack Size', type: 'number', unit: 'pcs', required: true },
                { key: 'diameter_mm', label: 'Diameter', type: 'number', unit: 'mm', step: 0.1 },
                { key: 'length_mm', label: 'Length', type: 'number', unit: 'mm' },
                { key: 'type', label: 'Type', type: 'select', options: ['Single', 'Ribbon', 'Splice Sleeve'] },
            ],
        },
    ],
    buildSku(v) {
        const parts = ['SPLPR', v.material ? v.material.substring(0, 4).toUpperCase() : '', v.diameter_mm, v.length_mm, v.packSize ? `${v.packSize}P` : ''];
        return parts.filter(Boolean).join('-').toUpperCase();
    },
    buildName(v) {
        const bits = [];
        if (v.material) bits.push(v.material);
        if (v.type) bits.push(v.type);
        if (v.diameter_mm && v.length_mm) bits.push(`${v.diameter_mm}x${v.length_mm}mm`);
        if (v.packSize) bits.push(`(${v.packSize} pcs/bag)`);
        bits.push('Splice Protector');
        return bits.join(' ');
    },
    attributeSchema: [
        { key: 'material', label: 'Material' },
        { key: 'type', label: 'Type' },
        { key: 'diameter_mm', label: 'Diameter', unit: 'mm' },
        { key: 'length_mm', label: 'Length', unit: 'mm' },
        { key: 'packSize', label: 'Pack Size' },
    ],
};